<app-spinner></app-spinner>
    <div class=" row vh-100" id="container">
                <div class="col-7 mt-3"></div>
                <div class="col-2 mt-3 text-right">
                </div>
                <div class="col-2 mt-3 mr-2">
                    <ng-select [multiple]="false" placeholder="Select Language" [items]="auth.allLanguage"
                        bindLabel="language_desc" bindValue="language_cd" [selectableGroup]="true"
                        [selectableGroupAsModel]="false" aria-placeholder="Select Language Code" [closeOnSelect]="false"
                        name="language_cd" [(ngModel)]="auth.language_cd" (change)="auth.changeLanguage()">
                    </ng-select>
                </div>
            <div class="col-2"></div>
            <div class="col-8" style="margin-top: -3%;">
                <div class="card">
                    <div class="card-body">
                        <div class="wrapper card-text overflow-hidden">
                            <div class="title-text d-flex mt-3 mb-4">
                                <div class="title otp-login text-center">
                                   <h3> Login with OTP </h3>
                                </div>
                                <div class="title gp-login text-center m" [hidden]="!login_with_password">
                                   <h3> Login with Password </h3>
                                </div>
                                <div class="title gp-login text-center m" [hidden]="login_with_password">
                                   <h3> Login with Google </h3>
                                </div>
                            </div>
                            <div class="row fit">
                                <div class="col-12 text-center">
                                    <div class="row ">
                                        <div class="col-1"></div>
                                        <div class="slide-controls col-10 ">
                                            <input type="radio" name="slide" id="otp-login" checked class="d-none">
                                            <input type="radio" name="slide" id="gp-login" class="d-none">
                                            <label for="otp-login"
                                                class="slide otp-login d-flex align-items-center justify-content-center ">
                                                <h5 class="card-text">Login with OTP</h5>
                                            </label>
                                            <label for="gp-login"  *ngIf="login_with_password"
                                                class="slide gp-login d-flex align-items-center justify-content-center ">
                                                <h5 class="card-text">Login with Password</h5>
                                            </label>
                                            <label for="gp-login"  *ngIf="!login_with_password"
                                                class="slide gp-login d-flex align-items-center justify-content-center ">
                                                <h5 class="card-text">Login with Google</h5>
                                            </label>
                                            <div class="slider-tab"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-container overflow-hidden">
                                <div class="form-inner">
                                    <form action="#" class="otp-login" [hidden]="false" autocomplete="off">
                                        <div class="row con-sub-tr" >
                                            <div class="col-12">
                                                <br *ngIf="!otp_flag">
                                                <div class="row mt-2 mb-1 ">
                                                    <div class="col-1"></div>
                                                    <div class="col-10">
                                                        <h6>Enter mobile number</h6>
                                                    </div>
                                                    <div class="col-1"></div>
                                                </div>
                                                <div class="row mt-1 mb-1">
                                                    <div class="col-1"></div>
                                                    <div class="col-10">
                                                        <input class="form-control" type="number" name="mobile_number"
                                                        (keyup)="allowLoginValidate()"
                                                        placeholder="{{auth.allLableShowObj[auth.language_cd+'LOGIN6']}}" autocomplete="off"
                                                        [(ngModel)]="mobile_number"  appRestirctNumberScroll>
                                                    </div>
                                                    <div class="col-1"></div>
                                                </div>
                                                <br *ngIf="!otp_flag">
                                                <div class="row mt-2 mb-1" *ngIf="otp_flag">
                                                    <div class="col-1"></div>
                                                    <div class="col-10">
                                                        <h6>Enter OTP</h6>
                                                    </div>
                                                    <div class="col-1"></div>
                                                </div>
                                                <div class="row mt-1 mb-1" *ngIf="otp_flag">
                                                    <div class="col-1"></div>
                                                    <div class="col-10">
                                                        <input class="form-control" id="text" type="password" name="otp_no"
                                                        placeholder="{{auth.allLableShowObj[auth.language_cd+'LOGIN12']}}" [(ngModel)]="otp_no">
                                                        <label>{{resendOTPMessage}}</label>
                                                    </div>
                                                    <div class="col-1"></div>
                                                </div>
                                                <div class="row mt-1 mb-4">
                                                    <div class="col-1"></div>
                                                    <div class="col-10 p-1 slide d-flex align-items-center justify-content-center">
                                                        <button [disabled]="resendOTPbutton"*ngIf="otp_flag" class="btn sub-con-1 w-100 sub-color" (click)="loginToAll()"  type="button"><h5 class="p-0 m-0">{{auth.allLableShowObj[auth.language_cd+'LOGIN11']}}</h5></button>
                                                        <button   *ngIf="!sendOTPbutonHide && !otp_flag" class="btn sub-con-1 w-100 sub-color" (click)="loginToAll()" type="button" [ngClass]="{'disabled':!checkMobileNumber(mobile_number)}"><h5 class="p-0 m-0">{{auth.allLableShowObj[auth.language_cd+'LOGIN10']}}</h5></button>
                                                        <button class="btn sub-con-1 w-100 sub-color" (click)="verifyLoginToAll()"  type="submit" [ngClass]="{'disabled':!checkMobileNumber(mobile_number) || !checkOTP(otp_no) || !otp_no}"><h5 class="p-0 m-0">{{auth.allLableShowObj[auth.language_cd+'LOGIN7']}}</h5></button>
                                                    </div>
                                                    <div class="col-1"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col-12 text-center">
                                                <h5>Login using your google account</h5>
                                            </div>
                                        </div>
                                    </form>
                                    <form action="#" class="gp-login" [hidden]="!login_with_password" autocomplete="off">
                                        <div class="row con-sub-tr" >
                                            <div class="col-12">
                                                <div class="row mt-3">
                                                    <div class="col-1"></div>
                                                    <div class="col-10">
                                                        <h6>{{auth.allLableShowObj[auth.language_cd+'LOGIN3']}}: <input type="checkbox"
                                                            style="margin-right:5%;" name="test"
                                                            [checked]="currentlyChecked === check_box_type.APPLY_FOR_JOB"
                                                            (click)="selectCheckBox(check_box_type.APPLY_FOR_JOB)">
                                                        {{auth.allLableShowObj[auth.language_cd+'LOGIN4']}}: <input type="checkbox" name="test"
                                                            [checked]="currentlyChecked === check_box_type.MODIFY_A_JOB"
                                                            (click)="selectCheckBox(check_box_type.MODIFY_A_JOB)"></h6>
                                                    </div>
                                                    <div class="col-1"></div>
                                                </div>
                                                <div class="row mt-2">
                                                    <div class="col-1"></div>
                                                    <div class="col-10">
                                                            <div class="form-group" *ngIf="currentlyChecked==0">
                                                                <input class="form-control" type="email" name="email" placeholder="Enter mobile number"
                                                                    autocomplete="off" [(ngModel)]="obj.email">
                                                            </div>
                                                            <div class="form-group" *ngIf="currentlyChecked!=0">
                                                                <input class="form-control" type="email" name="email" placeholder="Enter email"
                                                                    autocomplete="off" [(ngModel)]="obj.email">
                                                            </div>
                                                    </div>
                                                    <div class="col-1"></div>
                                                </div>
                                                <div class="row mt-3">
                                                    <div class="col-1"></div>
                                                    <div class="col-10">
                                                        <h6>Enter Password</h6>
                                                    </div>
                                                    <div class="col-1"></div>
                                                </div>
                                                <div class="row mt-2">
                                                    <div class="col-1"></div>
                                                    <div class="col-10">
                                                        <input class="form-control" id="password" type="password" name="password"
                                                        placeholder="{{auth.allLableShowObj[auth.language_cd+'LOGIN9']}}"
                                                        [(ngModel)]="obj.password">
                                                    </div>
                                                    <div class="col-1"></div>
                                                </div>
                                                <div class="row mt-4 mb-4">
                                                    <div class="col-1"></div>
                                                    <div class="col-10 p-1 slide d-flex align-items-center justify-content-center">
                                                        <button class="btn sub-con-1 w-100 sub-color " (click)="logins()"   type="button"><h5 class="p-0 m-0">{{auth.allLableShowObj[auth.language_cd+'LOGIN7']}}</h5></button>
                                                    </div>
                                                    <div class="col-1"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 text-center">
                                                <h5>Login using your google account</h5>
                                            </div>
                                        </div>
                                    </form>
                                    <form action="#" class="gp-login" [hidden]="login_with_password" autocomplete="off">
                                        <div class="row con-sub-tr" >
                                            <div class="col-12">
                                                <div class="row mt-3">
                                                    <div class="col-1"></div>
                                                    <div class="col-10">
                                                        <h6>Enter Mail Id</h6>
                                                    </div>
                                                    <div class="col-1"></div>
                                                </div>
                                                <div class="row mt-2">
                                                    <div class="col-1"></div>
                                                    <div class="col-10">
                                                        <input class="form-control" type="number" name="mobile_number"
                                                            (keyup)="allowLoginValidate()"
                                                            placeholder="{{auth.allLableShowObj[auth.language_cd+'LOGIN6']}}"
                                                            autocomplete="off" [(ngModel)]="mobile_number"
                                                            appRestirctNumberScroll>
                                                    </div>
                                                    <div class="col-1"></div>
                                                </div>
                                                <div class="row mt-3">
                                                    <div class="col-1"></div>
                                                    <div class="col-10">
                                                        <h6>Enter Password</h6>
                                                    </div>
                                                    <div class="col-1"></div>
                                                </div>
                                                <div class="row mt-2">
                                                    <div class="col-1"></div>
                                                    <div class="col-10">
                                                        <input class="form-control" type="number" name="mobile_number"
                                                            (keyup)="allowLoginValidate()"
                                                            placeholder="{{auth.allLableShowObj[auth.language_cd+'LOGIN6']}}"
                                                            autocomplete="off" [(ngModel)]="mobile_number"
                                                            appRestirctNumberScroll>
                                                    </div>
                                                    <div class="col-1"></div>
                                                </div>
                                                <div class="row mt-4 mb-4">
                                                    <div class="col-1"></div>
                                                    <div class="col-10 p-1 d-flex align-items-center justify-content-center">
                                                        <button class="btn w-100 sub-color"><h5 class="p-0 m-0">Submit</h5></button>
                                                    </div>
                                                    <div class="col-1"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-2"></div>
</div>

<div class="modal" id="forget">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <div class="modal-header">
                <h4 class="modal-title"> Forgot Password:</h4>
                <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body">
                <div class="row">

                    <div class="col-4 text-right">
                        Enter Phone Number:
                    </div>
                    <div class="col-6 text-center">
                        <input class="form-control" type="number" [(ngModel)]="phone_no" name="phone_no" />
                    </div>

                </div>
                <br *ngIf="your_password_flag">
                <div class="row" *ngIf="your_password_flag">

                    <div class="col-4 text-right">
                        Your Password:
                    </div>
                    <div class="col-6 text-center">
                        {{your_password}}
                    </div>

                </div>
                <br>
                <div class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" (click)="SubmitForgetPassword()">Submit</button>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" (click)="close()" class="btn btn-danger"
                    data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal" id="multi_account">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <div class="modal-header">
                <h4 class="modal-title"> {{auth.allLableShowObj[auth.language_cd+'LOGIN14']}}:</h4>
                <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body">
                <div class="row">

                    <div class="col-4 text-right">
                        {{auth.allLableShowObj[auth.language_cd+'LOGIN14']}} :
                    </div>
                    <div class="col-6 text-center">
                        <ng-select [items]="AllAccountData" bindLabel="acct_desc" bindValue="b_acct_id"
                            [multiple]="false" placeholder="{{auth.allLableShowObj[auth.language_cd+'LOGIN14']}}"
                            [(ngModel)]="b_account_id" [selectableGroup]="true" [selectableGroupAsModel]="false"
                            [closeOnSelect]="true" name="b_acct_id">
                        </ng-select>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" (click)="submitAccount()">Submit</button>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
